import { useState } from 'react'
import { Sidebar } from '../components/Sidebar'
import { ChatWindow } from '../components/ChatWindow'
import { useChat, type ChatSettings } from '../hooks/useChat'
import { SnippetProvider } from '../contexts/SnippetContext'

const DEFAULT_SETTINGS: ChatSettings = {
  mode: 'hybrid',
  top_k: 8,
  phrase: false,
  temperature: 0.1,
  categoryPresets: [],
}

export function ChatPage() {
  const [settings, setSettings] = useState<ChatSettings>(DEFAULT_SETTINGS)
  const {
    history,
    pending,
    error,
    isStreaming,
    send,
    stop,
    clear,
    attachedDocs,
    setAttachedDocs,
  } = useChat()

  return (
    <div className="flex flex-1 min-h-0">
      <Sidebar
        settings={settings}
        onSettingsChange={setSettings}
        onNewChat={clear}
        historyLen={history.length}
        isStreaming={isStreaming}
      />
      <SnippetProvider>
        <ChatWindow
          history={history}
          pending={pending}
          error={error}
          isStreaming={isStreaming}
          onSend={(text) => send(text, settings)}
          onStop={stop}
          attachedDocs={attachedDocs}
          onAttachmentsChange={setAttachedDocs}
        />
      </SnippetProvider>
    </div>
  )
}
